import axios from 'axios';
import {
  requestOnAxiosFullfilled,
  responseOnAxiosFullfilled,
  responseOnReject,
} from './interceptor';
import { logOut, setSession } from '@stb/module/auth/actions';
import { store } from '@stb/redux';
import swal from 'sweetalert';
import { createSwalButtons } from '../helper';

const apiSgb = axios.create({
  baseURL: process.env.REACT_APP_/dev/stb/web_GO_STB,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
});

// Global 401 error counter for all API calls (accessible across modules)
if (typeof window !== 'undefined') {
  window.__GLOBAL_401_COUNT__ = window.__GLOBAL_401_COUNT__ || 0;
}

// Function to invalidate session and logout user
function invalidateSession() {
  // Reset counter
  if (typeof window !== 'undefined') {
    window.__GLOBAL_401_COUNT__ = 0;
  }

  swal({
    icon: 'error',
    title: 'Sesi login Anda telah habis',
    text: 'Harap login ulang.',
    buttons: createSwalButtons('Oke'),
  }).then(() => {
    store.dispatch(setSession({ key: 'user', data: null }));
    store.dispatch(logOut());
  });
}

apiSgb.interceptors.request.use(requestOnAxiosFullfilled);

apiSgb.interceptors.response.use(responseOnAxiosFullfilled, async (err) => {
  if (err.response && err.response.status === 401) {
    if (typeof window !== 'undefined') {
      window.__GLOBAL_401_COUNT__++;
    }

    const currentCount = typeof window !== 'undefined' ? window.__GLOBAL_401_COUNT__ : 0;

    // Check if this is the 3rd consecutive 401
    if (currentCount >= 3) {
      invalidateSession();
      return Promise.reject(err);
    }

    // For 1st and 2nd 401s, let the request continue to the next interceptor
    // The responseOnReject in interceptor.js will handle token refresh
  } else if (!err.response) {
    // Reset counter on network errors or non-HTTP errors
    if (typeof window !== 'undefined') {
      window.__GLOBAL_401_COUNT__ = 0;
    }
  } else {
    // Reset counter on successful responses (non-401 errors)
    if (typeof window !== 'undefined') {
      window.__GLOBAL_401_COUNT__ = 0;
    }
  }

  return responseOnReject(err, apiSgb);
});

export default apiSgb;
